module.exports = __webpack_public_path__ + "dd508eeda6cb37195586059c39ccc27f.svg";